import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import { K } from '../constants';

const ToastCtx = createContext(() => {});

export const useToast = () => useContext(ToastCtx);

const COLORS = { success: K.ok, error: K.bad, info: K.info, warn: K.warn };

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);

  const toast = useCallback((msg, type = 'success', ms = 2500) => {
    const id = ++idRef.current;
    setToasts((t) => [...t, { id, msg, type, leaving: false }]);
    setTimeout(() => {
      setToasts((t) => t.map((x) => x.id === id ? { ...x, leaving: true } : x));
      setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 250);
    }, ms);
  }, []);

  return (
    <ToastCtx.Provider value={toast}>
      {children}
      <div style={{ position: 'fixed', bottom: 84, left: 0, right: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, zIndex: 9999, pointerEvents: 'none' }}>
        {toasts.map((t) => (
          <div
            key={t.id}
            style={{
              background: K.bg1,
              border: `1px solid ${COLORS[t.type] || K.bdr}`,
              borderLeft: `4px solid ${COLORS[t.type] || K.ok}`,
              color: K.t0,
              padding: '10px 18px',
              borderRadius: 10,
              fontSize: 13,
              fontWeight: 600,
              fontFamily: "'DM Mono', monospace",
              boxShadow: `0 8px 30px rgba(0,0,0,0.4)`,
              animation: t.leaving ? 'toastOut 0.25s ease-in forwards' : 'toastIn 0.25s ease-out',
              pointerEvents: 'auto',
              maxWidth: '85vw',
            }}
          >
            {t.msg}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}
